// extracted by mini-css-extract-plugin
export default {"previewHeader":"PIf1Yf","button":"pDdcqB","goToDesktop":"IoLXTM"};